import linkViewModel from '@vimcar/mvvm/linkViewModel'
import LabelCheckbox from '@vimcar/shared-components/components/LabelCheckbox'
import Paragraph from '@vimcar/shared-components/components/Paragraph'
import * as React from 'react'

import type { ViewModel, Props as VmProps } from './viewModel'

import BottomActions from '../BottomActions'
import StepContent from '../StepContent'
import styles from './styles.css'
import mkViewModel from './viewModel'

type Props = {
  viewModel: ViewModel
} & VmProps

const CheckboxesNode = ({ viewModel }: Props) => (
  <React.Fragment>
    <StepContent>
      <Paragraph variant='subtitle1'>{viewModel.title}</Paragraph>
      <Paragraph variant='body2'>{viewModel.subTitle}</Paragraph>
      {viewModel.options.map(([label, changeHandler]) => (
        <LabelCheckbox
          checkboxProps={{
            onChange: changeHandler.handleChange,
            checked: changeHandler.value,
          }}
          className={styles.checkbox}
          floatingLabelText={label}
          key={label}
        />
      ))}
      {viewModel.showError && <p className={styles.error}>{viewModel.error}</p>}
    </StepContent>
    <BottomActions
      // @ts-expect-error@2322
      nextEnabled={viewModel.isValid}
      onNext={viewModel.handleNext}
      showBack
    />
  </React.Fragment>
)

export default linkViewModel(mkViewModel, CheckboxesNode)
